"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _components = require("./components");
var _TableColumn = _interopRequireDefault(require("./TableColumn"));
const Table = _ref => {
  let {
    data,
    className,
    children,
    selectedField,
    onSelectionChange,
    onHeaderSelectionChange,
    onRowClick
  } = _ref;
  const columns = _react.default.useMemo(() => (0, _arkReact.childrenToReactElement)(children).filter(elementItem => elementItem.type.displayName === 'TableColumn').map((elementItem, idx) => {
    const {
      accessor,
      children: columnChildren,
      className: childrenClassName
    } = elementItem.props;
    let headerComponent = null;
    let cellComponent = null;
    (0, _arkReact.childrenToReactElement)(columnChildren).forEach(childrenItem => {
      if (childrenItem.type.displayName === 'TableColumnHeader') {
        headerComponent = childrenItem;
      }
      if (childrenItem.type.displayName === 'TableColumnCell') {
        cellComponent = childrenItem;
      }
    });
    return {
      id: idx.toString(),
      accessor,
      columnHeader: null,
      columnFilter: null,
      cellComponent,
      headerComponent,
      className: childrenClassName
    };
  }), [children]);
  const handleRowClick = _react.default.useCallback((rowId, cellIndex, data) => {
    if ((0, _ark.isFunction)(onRowClick)) {
      onRowClick({
        rowNum: rowId,
        cellIndex,
        data
      });
    }
  }, [onRowClick]);
  const handleRowSelectionChange = _react.default.useCallback((rowId, selectedData, selected) => {
    if (!(0, _ark.isFunction)(onSelectionChange)) return;
    onSelectionChange({
      rowNum: rowId,
      data: selectedData,
      selected
    });
  }, [onSelectionChange]);
  const handleHeaderSelectionChange = _react.default.useCallback(selected => {
    if (!(0, _ark.isFunction)(onHeaderSelectionChange)) return;
    if (!Array.isArray(data) || !(0, _ark.isString)(selectedField)) return;
    const anySelected = data.some(dataEntry => (0, _ark.getPropertySafe)(dataEntry, selectedField) === true);
    onHeaderSelectionChange({
      selected: !anySelected,
      items: data.map((dataItem, idx) => ({
        rowNum: idx,
        data: dataItem
      }))
    });
  }, [onHeaderSelectionChange, data]);
  return /*#__PURE__*/_react.default.createElement("table", {
    className: (0, _arkReact.concatClassName)('table', className)
  }, /*#__PURE__*/_react.default.createElement(_components.TableHeader, {
    data: data,
    columns: columns,
    selectedField: selectedField,
    onSelectionChange: handleHeaderSelectionChange
  }), /*#__PURE__*/_react.default.createElement(_components.TableBody, {
    data: data,
    columns: columns,
    selectedField: selectedField,
    onRowClick: handleRowClick,
    onSelectionChange: handleRowSelectionChange
  }));
};
process.env.NODE_ENV !== "production" ? Table.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  selectedField: _propTypes.default.string,
  onSelectionChange: _propTypes.default.func,
  onRowClick: _propTypes.default.func
} : void 0;
Table.defaultProps = {
  className: undefined,
  children: undefined,
  selectedField: undefined,
  onSelectionChange: undefined,
  onRowClick: undefined
};
var _default = exports.default = Object.assign(Table, {
  Column: _TableColumn.default
});